import type { Stage } from '@/core/types'
import { TEILNEHMERAKTE_ACTIONS, TEILNEHMERAKTE_STAGE } from './lib/teilnehmerakte'

export type VergabeStage =
  | 'aktivierung'
  | 'verbis'
  | 'teilnehmerakte'
  | 'kompetenzfeststellung'
  | 'kompetenzbilanzierung'
  | 'laufendeTeilnahme'
  | 'zwischenbericht'
  | 'abschlussOffen'
  | 'teilnahmeAbgeschlossen'

export type Column = {
  id: VergabeStage
  dbName: string
  clickable?: boolean
  personAction?: string
  listOnly?: boolean
}

export const COLUMNS: Column[] = [
  { id: 'aktivierung', dbName: "Aktivierung", clickable: true, personAction: 'open-aktivierung' },
  {
    id: 'verbis',
    dbName: "Auf VerBIS-Screenshots wartend",
    clickable: true,
    personAction: 'open-verbis-lebenslauf',
  },
  {
    id: TEILNEHMERAKTE_STAGE,
    dbName: "Teilnehmerakte & Erstgespräch",
    clickable: true,
    personAction: TEILNEHMERAKTE_ACTIONS.akte,
  },
  {
    id: 'kompetenzfeststellung',
    dbName: "Kompetenzfeststellung",
    clickable: true,
    personAction: 'open-kompetenzfeststellung',
  },
  {
    id: 'kompetenzbilanzierung',
    dbName: "Kompetenzbilanzierung, Förderplan und Erstbericht",
    clickable: true,
    personAction: 'open-kompetenzbilanzierung',
  },
  { id: 'laufendeTeilnahme', dbName: "Laufende Teilnahme", listOnly: true },
  { id: 'zwischenbericht', dbName: "Auf Zwischenbericht wartend", listOnly: true },
  { id: 'abschlussOffen', dbName: "Abschluss offen", listOnly: true },
  { id: 'teilnahmeAbgeschlossen', dbName: "Abgeschlossen", clickable: true, personAction: 'open-personal' },
]

export function stageForStatusName(name: string | null | undefined): VergabeStage | null {
  if (!name) return null
  return COLUMNS.find((c) => c.dbName === name)?.id ?? null
}

export function statusNameCandidatesFor(stage: Stage): string[] {
  const col = COLUMNS.find((c) => c.id === stage)
  return col ? [col.dbName] : [stage]
}
